import { render, staticRenderFns } from "./articleStandard.vue?vue&type=template&id=7d4f5df0&scoped=true&"
import script from "./articleStandard.vue?vue&type=script&lang=js&"
export * from "./articleStandard.vue?vue&type=script&lang=js&"
import style0 from "./articleStandard.vue?vue&type=style&index=0&id=7d4f5df0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4f5df0",
  null
  
)

export default component.exports